Backbone.emulateJSON = true;

lp.ar.SceneModel = Backbone.Model.extend({
	urlRoot: '/api/myscenes',
	save (attrs, options) {

		options = options || {};
		options.url = `${this.urlRoot}/scene/`;

		// if saving from outside AR page (e.g. PDP), then asset conflict should never occur
		attrs.IsAssetPage = $.isPlainObject(window.parent.lp.ar) && /\/viewer\//.test(window.parent.location.pathname);
		options.data = attrs;

		const previousAttributes = this.previousAttributes();
		const successCallback = options.success;

		options.success = (model, response) => {

			if (
				response.IsSuccessful === false
				|| (response.OperationResponse && !response.OperationResponse.IsSuccessful)
			) {

				// we dont need to restore token for UnauthorizedAction
				if (
					!(
						response.ErrorMessages
						&& response.ErrorMessages.length > 0
						&& response.ErrorMessages.indexOf('UnauthorizedAction') > -1
					)
				) {

					// reset token, otherwise if duplicate scene returns an error, there is no token
					this.set('Token', previousAttributes.Token, { silent: true });
					this.set('SceneName', previousAttributes.SceneName, { silent: true });
					this.set('Products', previousAttributes.Products, { silent: true });

				}

				lp.ar.processError(response, model);

			} else {

				// set version number to 1 if there's a new last accessed date, otherwise increment version number
				if (response.LastAccessedDate) {

					this.set('VersionNumber', 1, { silent: true });
					this.set('LastAccessedDate', response.LastAccessedDate, { silent: true });

				} else {

					this.set('VersionNumber', this.get('VersionNumber') + 1, { silent: true });
					this.set('LastAccessedDate', previousAttributes.LastAccessedDate, { silent: true });

				}

				lp.ar.processSuccess(response, model);

				if (successCallback) {

					successCallback(model);

				}

			}

		};

		Backbone.Model.prototype.save.call(this, attrs, options);

	},
	saveNote (note, { successCallback, errorCallback }) {

		const attrs = {
			Note: note,
			Overwrite: this.get('Overwrite'),
			VersionNumber: this.get('VersionNumber'),
			LastAccessedDate: this.get('LastAccessedDate')
		};
		const options = {
			url: `/api/myscenes/scene/${this.get('Token')}/notes/`,
			data: attrs,
			method: 'PUT',
			success: (model, response) => {

				if (response.IsSuccessful) {

					if (typeof successCallback === 'function') {

						successCallback(response);

					}

				} else {

					lp.ar.processError(response, model);

					if (typeof errorCallback === 'function') {

						errorCallback();

					}

				}

			},
			error: () => {

				$(lp.ar).trigger('showNoteError', { message: lp.ar.errorMessages.General });

				if (typeof errorCallback === 'function') {

					errorCallback();

				}

			},
			silent: true
		};

		Backbone.Model.prototype.save.call(this, attrs, options);

	},
	rename (newName, callback, errorCallBack) {

		$(lp.ar).trigger('messageAlert', { message: 'Updating...', fast: false });

		// if scene is empty and we're renaming it, then we must create a new scene
		if (!this.get('Token')) {

			// owner must be set to true, otherwise if there's a naming conflict, it will return incorrect error response
			this.set({ SceneName: newName, IsOwnerOfAsset: true }, { silent: true });
			// must trigger this manually and set silent to true, because if user tries entering the same name, nothing happens and request is not sent
			this.trigger('change');
			$(lp.ar).one('savedScene', () => callback());

		} else {

			$.ajax({
				url: `/api/myscenes/scene/operation/rename/${this.get('Token')}/`,
				type: 'PUT',
				data: {
					SceneName: newName,
					VersionNumber: this.get('VersionNumber'),
					LastAccessedDate: this.get('LastAccessedDate')
				},
				success: (response) => {

					if (
						response.IsSuccessful === false
						|| (response.OperationResponse && !response.OperationResponse.IsSuccessful)
					) {

						lp.ar.processError(response, this);
						errorCallBack();

					} else {

						$(lp.ar).trigger('messageAlert', { message: 'All changes auto saved', fast: false });
						this.set('VersionNumber', this.get('VersionNumber') + 1, { silent: true });
						this.set('SceneName', newName, { silent: true });
						$(lp.ar).trigger('reloadHeader');
						callback();

					}

				},
				error: () => {

					$(lp.ar).trigger('messageAlert', { message: 'Error', fast: false });
					errorCallBack();

				}
			});

		}

	},
	destroy (options) {

		this.set('id', this.get('Token'), { silent: true }); // must set id to set isNew to false

		options = options || {};
		if (options.url === undefined) {

			options.url = `${this.urlRoot}/scene/${this.get('Token')}/`;

		}

		return Backbone.Model.prototype.destroy.call(this, options);

	},
	fetchCurrent (options) {

		lp.ar.fetchingCurrent = true;

		options = options || {};
		if (options.url === undefined) {

			options.url = `${this.urlRoot}/currentscene`;

		}

		return Backbone.Model.prototype.fetch.call(this, options);

	},
	fetchLatestByToken (options, token) {

		options = options || {};
		if (options.url === undefined) {

			options.url = `${this.urlRoot}/scene/latest/${token}/`;

		}

		return Backbone.Model.prototype.fetch.call(this, options);

	},
	fetchByToken (options, token) {

		options = options || {};
		if (options.url === undefined) {

			options.url = `${this.urlRoot}/scene/${token}`;

		}

		return Backbone.Model.prototype.fetch.call(this, options);

	},
	publishToCustomer () {

		$.ajax({
			url: `${this.urlRoot}/currentscene/operation/publish`,
			type: 'POST',
			data: {},
			success (response) {

				const message = !response.OperationResponse.IsSuccessful
					? `Error: ${response.OperationResponse.ErrorMessages.toString()}`
					: 'Published to the customer';

				$(lp.ar).trigger('messageAlert', { message, fast: false });

			},
			error () {

				$(lp.ar).trigger('messageAlert', { message: 'Error', fast: false });

			}
		});

	}
});
